import type { Column } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';

import { UnstyledButton } from '../../../atoms/unstyled-button';

export const DataTableHeader = <T,>({
  column,
  title,
}: {
  column: Column<T>;
  title: string;
}) => {
  return (
    <UnstyledButton
      className="p-0"
      onPress={() => {
        column.toggleSorting(column.getIsSorted() === 'asc');
      }}
    >
      {title}
      <ArrowUpDown className="ml-2 h-4 w-4" />
    </UnstyledButton>
  );
};
